import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext({
  language: "en",
  isRTL: false,
  t: (key) => key,
  setLanguage: () => {},
  dir: "ltr",
});

const LANG_KEY = "app_language";

export function LanguageProvider({ children }) {
  const [language, setLangState] = useState(
    () => localStorage.getItem(LANG_KEY) === "ku" ? "ku" : "en"
  );
  const isRTL = language === "ku";
  const dir = isRTL ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", language);
  }, [dir, language]);

  const t = useCallback(
    (key) => translations[language]?.[key] || translations["en"]?.[key] || key,
    [language]
  );

  const setLanguage = useCallback((lang) => {
    setLangState(lang);
    localStorage.setItem(LANG_KEY, lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, isRTL, t, setLanguage, dir }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
